import { render, staticRenderFns } from "./CamujalSendTable.vue?vue&type=template&id=1e6b02e6&"
import script from "./CamujalSendTable.vue?vue&type=script&lang=js&"
export * from "./CamujalSendTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports